import EventManager from './event-manager';
import { DATASET_INITIALIZED } from '../constants/dataset';
import {
  EVENT_UPDATE_VIEW_EVENTS,
  EVENT_UPDATE_VIEW,
} from '../constants/event';

type Constructor<T> = new (element: HTMLElement) => T;

class ComponentInitializer {
  /**
   * コンポーネントを初期化する
   * @param selector 対象要素のセレクター
   * @param ComponentClass 初期化するコンポーネントのクラス
   * @param events トリガーとなるイベント配列
   */
  static initializeComponent<T>(
    selector: string | HTMLElement,
    ComponentClass: Constructor<T>
  ): void {
    EventManager.addEventListeners(document, EVENT_UPDATE_VIEW_EVENTS, () => {
      const elements: HTMLElement[] = Array.from(
        typeof selector === 'string'
          ? document.querySelectorAll(selector)
          : [selector]
      );
      elements.forEach((element) => {
        if (element.dataset[DATASET_INITIALIZED]) {
          return;
        }
        element.dataset[DATASET_INITIALIZED] = 'true';
        try {
          new ComponentClass(element as HTMLElement);
        } catch (error) {
          console.error(
            `Failed to initialize component for ${selector}:`,
            error
          );
          // 初期化に失敗した場合、データセットをリセット
          delete element.dataset[DATASET_INITIALIZED];
        }
      });
    });
  }

  /**
   * 複数のコンポーネントを一度に初期化する
   * @param configs コンポーネントの設定配列
   * @param events トリガーとなるイベント配列
   */
  static initializeComponents(
    configs: Array<{
      selector: string | HTMLElement;
      ComponentClass: Constructor<any>;
    }>
  ): void {
    EventManager.addEventListeners(document, EVENT_UPDATE_VIEW_EVENTS, () => {
      configs.forEach(({ selector, ComponentClass }) => {
        const elements: HTMLElement[] = Array.from(
          typeof selector === 'string'
            ? document.querySelectorAll(selector)
            : [selector]
        );
        elements.forEach((element) => {
          if (element.dataset[DATASET_INITIALIZED]) {
            return;
          }
          element.dataset[DATASET_INITIALIZED] = 'true';
          try {
            new ComponentClass(element as HTMLElement);
          } catch (error) {
            console.error(
              `Failed to initialize component for ${selector}:`,
              error
            );
            // 初期化に失敗した場合、データセットをリセット
            delete element.dataset[DATASET_INITIALIZED];
          }
        });
      });
    });
  }

  /**
   * ビューの更新イベントを発火する
   */
  static fireUpdateViewEvent() {
    document.dispatchEvent(new CustomEvent(EVENT_UPDATE_VIEW));
  }
}

export default ComponentInitializer;
